import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=40e8ae93&scoped=true"
import script from "./messageList.vue?vue&type=script&lang=js"
export * from "./messageList.vue?vue&type=script&lang=js"
import style0 from "./messageList.vue?vue&type=style&index=0&id=40e8ae93&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e8ae93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e8ae93')) {
      api.createRecord('40e8ae93', component.options)
    } else {
      api.reload('40e8ae93', component.options)
    }
    module.hot.accept("./messageList.vue?vue&type=template&id=40e8ae93&scoped=true", function () {
      api.rerender('40e8ae93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/messageList.vue"
export default component.exports